// Animated first-load splash + quiet mid-session loading screen.
// Mirrors the seshly website splash: green screen, white "seshly." rising from
// the bottom, then PLAN (left) · TRACK (bottom) · GROW (right) flying in.
// Pure CSS keyframes — no framer-motion dependency.

const SPLASH_CSS = `
  @keyframes seshlyRise {
    0%   { transform: translateY(55vh); opacity: 0; }
    100% { transform: translateY(0);    opacity: 1; }
  }
  @keyframes flyFromLeft {
    0%   { transform: translateX(-60px); opacity: 0; }
    100% { transform: translateX(0);     opacity: 1; }
  }
  @keyframes flyFromBottom {
    0%   { transform: translateY(32px); opacity: 0; }
    100% { transform: translateY(0);    opacity: 1; }
  }
  @keyframes flyFromRight {
    0%   { transform: translateX(60px); opacity: 0; }
    100% { transform: translateX(0);    opacity: 1; }
  }
  @keyframes dotFade {
    0%, 40% { opacity: 0; }
    100%    { opacity: 0.45; }
  }
  @keyframes quietPulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50%      { opacity: 0.75; transform: scale(0.985); }
  }
`;

const EASE = "cubic-bezier(0.22, 1, 0.36, 1)";

const wordBase = {
  fontFamily: "Inter, Arial, sans-serif",
  fontSize: "clamp(11px, 3.4vw, 15px)",
  fontWeight: 700,
  letterSpacing: "0.26em",
  color: "#ffffff",
  textTransform: "uppercase",
};

const dotBase = {
  color: "#ffffff",
  fontSize: 10,
};

// Full animated splash — used only on the very first app load.
export function SplashScreen() {
  return (
    <div
      className="min-h-dvh flex flex-col items-center justify-center overflow-hidden"
      style={{ background: "#10B981" }}
      data-testid="splash-screen"
    >
      <style>{SPLASH_CSS}</style>

      {/* seshly. — rises from the bottom to centre */}
      <div
        style={{
          fontFamily: "Inter, Arial, sans-serif",
          fontSize: "clamp(56px, 16vw, 96px)",
          fontWeight: 900,
          color: "#ffffff",
          letterSpacing: "-1px",
          lineHeight: 1,
          animation: "seshlyRise 0.75s cubic-bezier(0.22,1,0.36,1) both",
        }}
      >
        seshly.
      </div>

      {/* PLAN · TRACK · GROW — fly in from left / bottom / right, then stay */}
      <div className="flex items-center gap-3" style={{ marginTop: 14 }}>
        <span style={{ ...wordBase, animation: `flyFromLeft 0.5s 0.9s ${EASE} both` }}>PLAN</span>
        <span style={{ ...dotBase, animation: "dotFade 0.4s 1.0s ease both" }}>·</span>
        <span style={{ ...wordBase, animation: `flyFromBottom 0.5s 1.0s ${EASE} both` }}>TRACK</span>
        <span style={{ ...dotBase, animation: "dotFade 0.4s 1.1s ease both" }}>·</span>
        <span style={{ ...wordBase, animation: `flyFromRight 0.5s 1.1s ${EASE} both` }}>GROW</span>
      </div>
    </div>
  );
}

// Quiet static green screen — used mid-session while the profile re-fetches.
// No fly-in; just a gentle pulse so it never looks broken on repeat renders.
export function LoadingScreen() {
  return (
    <div
      className="min-h-dvh flex flex-col items-center justify-center"
      style={{ background: "#10B981" }}
      data-testid="loading-screen"
    >
      <style>{SPLASH_CSS}</style>
      <div
        className="flex flex-col items-center"
        style={{ animation: "quietPulse 1.4s ease-in-out infinite" }}
      >
        <div
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontSize: "clamp(48px, 14vw, 84px)",
            fontWeight: 900,
            color: "#ffffff",
            letterSpacing: "-1px",
            lineHeight: 1,
          }}
        >
          seshly.
        </div>
        <div
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontSize: "clamp(10px, 3vw, 14px)",
            fontWeight: 700,
            letterSpacing: "0.26em",
            color: "rgba(255,255,255,0.85)",
            textTransform: "uppercase",
            marginTop: 12,
          }}
        >
          PLAN · TRACK · GROW
        </div>
      </div>
    </div>
  );
}
